module.exports = require("./ff-Latn-GW.d.ts");